import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://www.lord.live';
const DEFAULT_IMAGE = `${SITE_URL}/newaboutpic.jpg`;

// Per-route <title>/description/OG/Twitter tags. Rendered once per page via
// react-helmet-async so each route gets distinct metadata instead of the
// single static block in public/index.html.
const SEO = ({ title, description, path = '/', image = DEFAULT_IMAGE }) => {
    const url = path === '/' ? SITE_URL : `${SITE_URL}${path}`;
    const fullTitle = path === '/' ? title : `${title} | Lord Crawford`;

    return (
        <Helmet>
            <title>{fullTitle}</title>
            <meta name="description" content={description} />
            <link rel="canonical" href={url} />

            <meta property="og:type" content="website" />
            <meta property="og:url" content={url} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={image} />

            <meta property="twitter:card" content="summary_large_image" />
            <meta property="twitter:url" content={url} />
            <meta property="twitter:title" content={fullTitle} />
            <meta property="twitter:description" content={description} />
            <meta property="twitter:image" content={image} />
        </Helmet>
    );
};

export default SEO;
